import ApiService from '../../services/api.service.js';

export const state = {
  budgets: [],
  oneBudget: {},
  isLoading: false
};

export const mutations = {
  SET_BUDGETS(state, newValue) {
    state.budgets = newValue;
  },
  SET_ONE_BUDGET(state, newValue) {
    state.oneBudget = newValue;
  },
  SET_LOADING(state, newValue) {
    state.isLoading = newValue;
  }
};

export const getters = {
  getBudgets(state) {
    return state.budgets;
  },
  getOneBudget(state) {
    return state.oneBudget;
  },
  getLoading(state) {
    return state.isLoading;
  }
};

export const actions = {
  async getBudgetList({ commit }, query) {
    try {
      commit('SET_LOADING', true);

      const response = await ApiService.get('/finance/department-budget?' + new URLSearchParams(query));

      if (response.status === 200) {
        commit('SET_BUDGETS', response.data);
      }
    } catch (error) {
      // errors are surfaced by the API interceptor / AlertService
    } finally {
      commit('SET_LOADING', false);
    }
  }
};
